var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { BRow, BCol, BOverlay } from 'bootstrap-vue';
import debounce from 'lodash/debounce';
let MountVisualisation = class MountVisualisation extends Vue {
    constructor() {
        super(...arguments);
        this.loading = true;
        this.url = '#';
        this.debouncedUpdateUrl = debounce(this.updateUrl, 250);
    }
    updateUrl() {
        let getParams = {
            length: String(this.externalSize.length),
            width: String(this.externalSize.width),
            apLength: String(this.apertureSize.length),
            apWidth: String(this.apertureSize.width),
            code: this.board ? this.board.stock_lookup_sku : '8001'
        };
        if (this.topBorder) {
            getParams.apTop = String(this.topBorder);
        }
        if (this.leftBorder) {
            getParams.apLeft = String(this.leftBorder);
        }
        let params = new URLSearchParams(getParams);
        this.url = '/api/visualisations/mountboard?' + params.toString();
    }
    onVisUrlChange(newValue, oldValue) {
        if (newValue !== oldValue)
            this.loading = true;
    }
};
__decorate([
    Prop(Object)
], MountVisualisation.prototype, "board", void 0);
__decorate([
    Prop(Object)
], MountVisualisation.prototype, "externalSize", void 0);
__decorate([
    Prop(Object)
], MountVisualisation.prototype, "apertureSize", void 0);
__decorate([
    Prop({ type: Number, default: null })
], MountVisualisation.prototype, "topBorder", void 0);
__decorate([
    Prop({ type: Number, default: null })
], MountVisualisation.prototype, "leftBorder", void 0);
__decorate([
    Watch('board', { deep: true }),
    Watch('externalSize', { deep: true }),
    Watch('apertureSize', { deep: true }),
    Watch('topBorder'),
    Watch('leftBorder')
], MountVisualisation.prototype, "debouncedUpdateUrl", void 0);
__decorate([
    Watch('url')
], MountVisualisation.prototype, "onVisUrlChange", null);
MountVisualisation = __decorate([
    Component({
        components: {
            BRow, BCol, BOverlay
        }
    })
], MountVisualisation);
export default MountVisualisation;
